import {object, string, array, date, ref, boolean, number} from "yup";
import {
    getPartialValidationEmailReceipts,
    getPartialValidationLivestreams,
    getPartialValidationSportEvents,
    getPartialValidationMatchPointConfig,
    getPartialValidationLocalRecInfo
} from "../../utils";
import getPartialValidationSchemaAdmin from "./partial-validation-schema-admin";


export default ({
                    intl,
                    hasAdminPrivileges,
                    canEditEventType = false,
                    canEditRoomTemplate = false,
                    hasRoomTemplates = false,
                    isSportEvent,
                    showSportDataConfig,
                    showLocalRecEventFields
                }) => {
    const requiredText = intl.formatMessage({id: "app.form.required"});
    const notADate = intl.formatMessage({id: "app.form.notadate"});
    const notANumber = intl.formatMessage({id: "app.form.notanumber"});
    const startDateNotAfterEndDate = intl.formatMessage({id: "app.form.startDateNotAfterEndDate"});
    const endDateNotBeforeStartDate = intl.formatMessage({id: "app.form.endDateNotBeforeStartDate"});

    const eventTypeRestriction = canEditEventType
        ? {
            typeId: string().required(requiredText),
        }
        : {};

    const roomTemplateRestriction = canEditRoomTemplate
        ? {
            roomTemplateId: hasRoomTemplates ? string().required(requiredText) : string().nullable(),
            tyoe: string(),
        }
        : {};
    return object().shape({
        title: string().required(requiredText),
        description: string().required(requiredText),
        startDate: date()
            .required(requiredText)
            .typeError(notADate)
            .when("endDate", {
                is: endDate => endDate !== null,
                then: strDate => strDate.max(ref("endDate"), startDateNotAfterEndDate),
            }),
        endDate: date()
            .required(requiredText)
            .typeError(notADate)
            .min(ref("startDate"), endDateNotBeforeStartDate),
        keywords: array().of(string().required(requiredText)),
        liveStreams: array().of(getPartialValidationLivestreams({intl})),
        graphicSetId: string().nullable(),
        emailReceipts: array().of(getPartialValidationEmailReceipts({intl})),
        localRec: boolean(),
        activeQod: boolean(),
        isMutedOnStart: boolean(),
        unmuteMinutesBefore: number()
            .typeError(notANumber)
            .when("isMutedOnStart", {
                is: true,
                then: schema => schema.required(requiredText).min(0).max(20),
                otherwise: schema => schema.nullable(),
            }),
        visible: boolean().required(requiredText),
        billable: boolean().required(requiredText),
        isInternalTest: boolean(),
        ...eventTypeRestriction,
        ...roomTemplateRestriction,
        ...getPartialValidationSportEvents({
            intl,
            isSportEvent,
            showSportDataConfig,
            showLocalRecEventFields,
            scoreboardTypeRequired: false,
        }),
        ...getPartialValidationMatchPointConfig({intl, isSportEvent}),
        ...getPartialValidationSchemaAdmin({intl, hasAdminPrivileges}),
        ...getPartialValidationLocalRecInfo({intl}),
    });
};
